import { withQuery } from './lib/withQuery'

export const getAuthorCollectionsUrl = (username: string) => withQuery('collections', { username })

export const getCollectionByIdUrl = (id: string) => withQuery('collections/view', { id })

export const getAuthorCollectionUrl = (username: string, slug: string) =>
    withQuery('collection', { username, slug })

export const getCollectionAudiosUrl = (username: string, slug: string) =>
    withQuery('collection/items', { username, slug })

export const getDownloadUrlForCollectionUrl = (id: string) =>
    withQuery('collection/download', { id })

export const updateCollectionUrl = (id: string) => withQuery('collection', { id })

export const deleteCollectionUrl = (id: string) => withQuery('collection', { id })

export const addAudioToCollectionUrl = (id: string) => withQuery('collection/item', { id })

export const deleteAudioFromCollectionUrl = (id: string) => withQuery('collection/item', { id })

export const createCollectionUrl = () => 'collection'

export const updateCollectionItemOrderUrl = ({
    collectionId,
    audioId,
}: {
    collectionId: string
    audioId: string
}) => withQuery('collection/item', { collection: collectionId, audio: audioId })
